
import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/modules/authentication/models/user';
import { Location } from '@/modules/nomenclature/models/location';
import { BudgetLine } from '@/modules/nomenclature/models/budgetLine';
import SubjectLocationPicker from '@/modules/analysis/components/create-request/inputs/SubjectLocationPicker.vue';
import SubjectBudgetLinePicker from '@/modules/analysis/components/create-request/inputs/SubjectBudgetLinePicker.vue';
import * as UsersService from '@/modules/authentication/services/usersService';
import * as LocationService from '@/modules/nomenclature/services/locationService';
import * as ProjectService from '@/modules/nomenclature/services/projectService';

@Component({
  components: { SubjectLocationPicker, SubjectBudgetLinePicker }
})
export default class Users extends Vue {
  protected dialog = false;
  protected inputUser: User | null = null;
  protected location: Location | null = null;
  protected budgetLine: BudgetLine | null = null;
  protected loading = true;
  protected headers = [
    { value: 'givenName', text: this.$i18n.t('authentication.Users.headers.givenName').toString() },
    { value: 'familyName', text: this.$i18n.t('authentication.Users.headers.familyName').toString() },
    { value: 'email', text: this.$i18n.t('authentication.Users.headers.email').toString() },
    { value: 'actions', text: this.$i18n.t('authentication.Users.headers.actions').toString(), sortable: false }
  ];
  protected users: User[] = [];
  protected mounted(): void {
    UsersService.fetchAll().then((response) => {
      this.loading = false;
      this.users = response.data;
    });
  }

  protected editUser(user: User): void {
    this.inputUser = Object.assign({}, user);
    if (this.inputUser.locationId) {
      LocationService.fetchById(this.inputUser.locationId).then((response) => {
        this.location = response.data;
      });
    } else {
      this.location = null;
    }
    if (this.inputUser.budgetLineId) {
      ProjectService.fetchBudgetLineById(this.inputUser.budgetLineId).then((response) => {
        this.budgetLine = response.data;
      });
    } else {
      this.budgetLine = null;
    }
    this.dialog = true;
  }

  protected saveUser(): void {
    if (this.inputUser) {
      UsersService.update(this.inputUser).then((response) => {
        this.refreshUser(response.data);
        this.dialog = false;
        setTimeout(() => {
          this.inputUser = null;
        }, 500);
      });
    }
  }

  private refreshUser(userParam: User): void {
    let targetIdx = -1;
    const found = this.users.some((value, index) => {
      if (value.id === userParam.id) {
        targetIdx = index;
        return true;
      }
      return false;
    });
    if (found) {
      Vue.set(this.users, targetIdx, userParam);
    }
  }

  /**
   * The user has selected a location: use it as an argument to retrieve the current budgets here.
   */
  protected onLocationChange(locationId: string): void {
    LocationService.fetchById(locationId).then((response) => {
      this.location = response.data;
      if (this.inputUser) {
        this.inputUser.locationId = locationId;
      }
    });
  }

  /**
   * The user wants to chose another location : we have to clear other choices
   */
  protected onLocationClear(): void {
    this.location = null;
    if (this.inputUser) {
      this.inputUser.locationId = null;
    }
  }

  /**
   * The user has selected a budget line inside project.
   */
  protected onBudgetLineChange(budgetLineId: string): void {
    ProjectService.fetchBudgetLineById(budgetLineId).then((response) => {
      this.budgetLine = response.data;
      if (this.inputUser) {
        this.inputUser.budgetLineId = budgetLineId;
      }
    });
  }

  /**
   * The user wants to chose another location : we have to clear other choices
   */
  protected onBudgetLineClear(): void {
    this.budgetLine = null;
    if (this.inputUser) {
      this.inputUser.budgetLineId = null;
    }
  }
}
